import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrdersUtil } from "../../../utility";
const useSales = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { sale_orders } = useSelector((state) => state.orders);
  const [currentPage, setCurrentPage] = useState(() => {
    const p = parseInt(localStorage.getItem("saleOrderPage"), 10);
    return !isNaN(p) ? p : 1;
  });
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0)
  const [selectedOrderStatus, setSelectedOrderStatus] = useState(() => {
    return localStorage.getItem("selectedOrderStatus") || "New";
  });
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState("All Payments Status");
  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [loading, setLoading] = useState(false)
  const [showSlider, setShowSlider] = useState(false);
  const [searchValue, setSearchValue] = useState(() => {
    return localStorage.getItem("search") || "";
  });
  const [canSearch, setCanSearch] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [orders, setOrders] = useState(sale_orders ?? []);
  const [duplicateOrders, setDuplicateOrders] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCriticalOrders, setShowCriticalOrders] = useState(false);
  const [criticalOrdersCount, setCriticalOrdersCount] = useState(false)
  const [sortOrder, setSortOrder] = useState("desc");
  const handleCriticalOrderClick = () => {
    setShowCriticalOrders((prevState) => !prevState);
  };
  const gettingOrders = () => {
    const normalizedOrderStatus = selectedOrderStatus === "All Orders" ? "" : selectedOrderStatus;
    const normalizedPaymentStatus = selectedPaymentStatus === "All Payments Status" ? "" : selectedPaymentStatus;
    fetchOrdersUtil({
      startDate,
      endDate,
      critical: showCriticalOrders ? true : "",
      status: normalizedOrderStatus,
      paymentStatus: normalizedPaymentStatus,
      page: currentPage,
      pageSize: itemsPerPage,
      search: searchValue,
      sort: sortOrder,
      setLoading,
      dispatch,
      setTotalPages,
      setCriticalOrdersCount
    });
  };


  useEffect(() => {
    localStorage.setItem("selectedOrderStatus", selectedOrderStatus);
  }, [selectedOrderStatus]);

  useEffect(() => {
    localStorage.setItem("search", searchValue);
  }, [searchValue]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingOrders();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    startDate,
    endDate,
    showCriticalOrders,
    selectedOrderStatus,
    selectedPaymentStatus,
    currentPage,
    searchValue,
    sortOrder,
    itemsPerPage
  ]);

  useEffect(() => {
    setOrders(sale_orders ?? []);
    setDuplicateOrders(sale_orders ?? []);
  }, [sale_orders]);
  useEffect(() => {
    if (dateRange?.length > 0 && dateRange.length === 2 && dateRange[0]) {
      const sDate = dateRange[0].startOf('day').valueOf();
      const eDate = dateRange[1].endOf('day').valueOf();
      setStartDate(sDate)
      setEndDate(eDate)
    } else {
      setStartDate("")
      setEndDate("")
    }
  }, [dateRange])
  return {
    searchValue,
    setSearchValue,
    sale_orders,
    orders,
    setOrders,
    duplicateOrders,
    setDuplicateOrders,
    dispatch,
    // handleOnSearchData,
    canSearch,
    setCanSearch,
    selectedData,
    setSelectedData,
    selectedRows,
    setSelectedRows,
    selectedOrderStatus,
    setSelectedOrderStatus,
    selectedPaymentStatus,
    setSelectedPaymentStatus,
    dateRange,
    setDateRange,
    showSlider,
    setShowSlider,
    handleCriticalOrderClick,
    showCriticalOrders,
    selectedDate,
    setSelectedDate,
    user, gettingOrders,
    sortOrder, setSortOrder,
    totalPages, currentPage, itemsPerPage, setItemsPerPage, loading, setLoading, setCurrentPage, criticalOrdersCount
  };
};
export default useSales;
